import { Component, OnDestroy, OnInit } from '@angular/core';
import { Account, Customer, CustomerAccountItem } from '@inyova/models';
import { TranslateService } from '@ngx-translate/core';

import { select, Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import * as AppRootActions from '@app/app.actions';
import * as fromAppRoot from '@app/app.reducers';

@Component({
  selector: 'app-account-opening-blocker',
  templateUrl: 'account-opening-blocker.component.html',
  styleUrls: ['account-opening-blocker.component.scss'],
  standalone: false
})
export class AppAccountOpeningBlockerComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  customer: Customer;
  currentAccount: Account;

  constructor(
    private store: Store,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.store.pipe(select(fromAppRoot.selectCustomerAndCurrentAccount), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.customer = value.customer;
      this.currentAccount = value.currentAccountDetail;
    });
  }

  onClickCta(): void {
    const otherAccountType = this.currentAccount.kind === '3b' ? 'grow' : '3b';
    const otherAccount = this.customer.temporary_accounts.find((account) => account.kind === otherAccountType);
    this.switchAccount(otherAccount);
  }

  switchAccount(account: CustomerAccountItem): void {
    this.store.dispatch(
      AppRootActions.setSwitchAccountLoading({
        show: true,
        message: this.translateService.instant(`fullLoader.switchingAccountType.${account.kind}`, {
          kidsName: account.owner_name
        })
      })
    );
    this.store.dispatch(AppRootActions.switchAccount({ id: account.id, redirectUrl: null }));
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
